type Props = {
  total: number
}

const Counter = ({ total }: Props) => {
  const vehicle = total === 1 ? 'vehicle' : 'vehicles'

  return (
    <span className="flex basis-1/2 md:basis-1/3 order-2 md:order-1 text-lg">
      {total} {vehicle} available
    </span>
  )
}

export default Counter
